import NewsletterSubmitProvider from './hooks/useNewsletterSubmit';

import { NewsletterSubmitProps } from './@types/NewsletterSubmitProps';
import NewsletterSubmitContainer from './handles/NewsletterSubmitContainer';

const NewsletterSubmit = (props: NewsletterSubmitProps) => (
	<NewsletterSubmitProvider {...props}>
		<NewsletterSubmitContainer />
	</NewsletterSubmitProvider>
);

export default NewsletterSubmit;
